import CadastroClusterTrv from "../../components/CadastroClusterTrv/CadastroClusterTrv"

function TrvCadastroCluster() {
    

    return (
        <>
            <CadastroClusterTrv />
        </>
    )
}

export default TrvCadastroCluster